import React from 'react';
import { X } from 'lucide-react';

const SubscriptionModal = ({
  isOpen,
  onClose,
  subscriptionEmail,
  setSubscriptionEmail,
  subscriptionStatus,
  onSubmit
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={onClose}></div>

        {/* Modal */}
        <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
          {/* Close button */}
          <button 
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>

          {!subscriptionStatus ? (
            <>
              <h2 className="mb-4 text-2xl font-bold text-gray-900">Start Your Free Trial</h2>
              <p className="mb-6 text-gray-600">Enter your email to begin your 7-day free trial.</p>
              <form onSubmit={onSubmit} className="space-y-4">
                <input
                  type="email"
                  value={subscriptionEmail}
                  onChange={(e) => setSubscriptionEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full rounded-lg border border-gray-300 p-3 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                  required
                />
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 text-gray-600 hover:text-gray-800"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-lg bg-purple-600 px-6 py-2 text-white hover:bg-purple-700"
                  >
                    Start Free Trial
                  </button>
                </div>
              </form>
            </>
          ) : subscriptionStatus.error ? (
            <div className="text-center">
              <h2 className="mb-4 text-xl font-bold text-red-600">Error</h2>
              <p className="mb-6">{subscriptionStatus.error}</p>
              <button
                onClick={() => {
                  setSubscriptionEmail('');
                  onClose();
                }}
                className="rounded-lg bg-purple-600 px-6 py-2 text-white hover:bg-purple-700"
              >
                Try Again
              </button>
            </div>
          ) : subscriptionStatus.status === 'new_user' ? (
            <div className="text-center">
              <h2 className="mb-4 text-2xl font-bold text-green-600">Success!</h2>
              <div className="mb-6">
                <p className="mb-4 text-lg text-gray-700">
                  Check your email for instructions to access your free trial.
                </p>
                <div className="rounded-lg bg-gray-50 p-4">
                  <p className="mb-3 font-medium text-gray-700">Next steps:</p>
                  <ol className="space-y-2 text-left text-gray-600">
                    <li className="flex items-center">
                      <span className="mr-2 text-purple-600">1.</span>
                      Check your email for confirmation
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-purple-600">2.</span>
                      Click the verification link
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-purple-600">3.</span>
                      Create your account
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-purple-600">4.</span>
                      Start learning!
                    </li>
                  </ol>
                </div>
              </div>
              <button
                onClick={onClose}
                className="w-full rounded-lg bg-purple-600 px-4 py-2 text-white hover:bg-purple-700"
              >
                Got it!
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
